// extracted by mini-css-extract-plugin
export default {"showScoresTitle":"JjCjcBbxtC2UUmjW2bmT"};